import React, { useCallback, useEffect, useState } from 'react';
import { fetchAuditLog, AuditLine } from './authApi';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';

export function AuditLogPage() {
  const [lines, setLines] = useState<AuditLine[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchAuditLog(200);
      setLines(data);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load audit log');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="audit-log-panel">
      <div className="audit-log-header">
        <h2>Audit log</h2>
        <button type="button" className="button secondary" onClick={load} disabled={loading}>
          <RefreshOutlinedIcon fontSize="small" />
          Refresh
        </button>
      </div>
      {error && <div className="auth-error">{error}</div>}
      {loading && !error && <p>Loading audit log…</p>}
      {!loading && !error && lines.length === 0 && <p>No audit entries yet.</p>}
      {!loading && lines.length > 0 && (
        <div className="audit-log-table-wrap">
          <table className="audit-log-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>IP</th>
                <th>Action</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {lines.map((row, i) => (
                <tr key={`${row.time}-${row.action}-${i}`}>
                  <td>{row.time || '—'}</td>
                  <td>{row.user || '—'}</td>
                  <td>{row.ip || '—'}</td>
                  <td><code>{row.action || '—'}</code></td>
                  <td>{row.detail || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
